import React from 'react';
import BackComponent from "../components/BackComponent";

export default class ContactPage extends React.Component {

	render() {


		return(
			<div className="container-fluid contact">
				<div className="row" >
					<div className="container-fluid">
						<BackComponent />
					</div>
				</div>
			</div>
		);
	}

}

